import { useState, useEffect } from 'react'

/**
 * Хук для отслеживания медиа-запросов
 * @param query - CSS медиа-запрос, например '(max-width: 768px)'
 * @returns boolean - соответствует ли текущий viewport запросу
 */
export function useMediaQuery (query: string): boolean {
  const [ matches, setMatches ] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches
    }
    return false
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    const mediaQuery = window.matchMedia(query)
    
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    // Устанавливаем начальное значение
    setMatches(mediaQuery.matches)

    // Подписываемся на изменения
    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [ query ])

  return matches
}

/**
 * Хук для определения мобильного устройства (ширина <= 768px)
 */
export function useIsMobile (): boolean {
  return useMediaQuery('(max-width: 768px)')
}

/**
 * Хук для определения планшета (ширина <= 1024px)
 */
export function useIsTablet (): boolean {
  return useMediaQuery('(max-width: 1024px)')
}
